import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Bot } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const ChatBotCta: React.FC = () => (
  <AnimatedSection as="section" className="cbot-cta" aria-labelledby="cbot-cta-title">
    <div className="cbot-container">
      <motion.div
        className="cbot-cta__inner"
        whileHover={{ scale: 1.005 }}
        transition={{ duration: 0.3 }}
      >
        <div className="cbot-cta__icon" aria-hidden="true">
          <Bot size={32} />
        </div>
        <div className="cbot-cta__text">
          <h2 id="cbot-cta-title">Ready To Build Your AI Chatbot?</h2>
          <p>Transform customer interactions with intelligent automation.</p>
        </div>
        <div className="cbot-cta__actions">
          <Link to="/contact" className="cbot-cta__btn cbot-cta__btn--primary">
            Get Free Consultation
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <Link to="/contact" className="cbot-cta__btn cbot-cta__btn--ghost">
            Schedule Demo
          </Link>
        </div>
      </motion.div>
    </div>
  </AnimatedSection>
);

export default ChatBotCta;
